/* A fresh selection on repeat homepage views; the first view, the editor and no-JS keep the curated covers. */
if (!customElements.get('tandoori-featured-shuffle')) {
  customElements.define('tandoori-featured-shuffle', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized || this.hasAttribute('data-static')) return;
      this.initialized = true;
      const slots = [...this.querySelectorAll('.tb-hero__book')];
      const source = this.closest('.tb-store')?.querySelector('[data-finder-data]');
      if (!source || !slots.length) return;
      try {
        const unique = new Map();
        for (const book of JSON.parse(source.textContent).books) {
          if (book.image && new URL(book.url, location.origin).origin === location.origin) unique.set(String(book.id), book);
        }
        const books = [...unique.values()];
        if (books.length < slots.length) return;
        const storageKey = 'tandoori-featured-books';
        let stored = null;
        try { stored = sessionStorage.getItem(storageKey); } catch { /* Storage is optional. */ }
        // The first homepage view of a session keeps the curated covers: no extra downloads or swap.
        if (stored === null) {
          try { sessionStorage.setItem(storageKey, '[]'); } catch { /* Storage is optional. */ }
          return;
        }
        let previous = [];
        try { previous = JSON.parse(stored); } catch { /* Start fresh. */ }
        if (!Array.isArray(previous)) previous = [];
        // Size each replacement cover to its slot instead of a fixed 500px.
        const sized = (book, slot) => {
          const needed = (slot.clientWidth || 180) * (window.devicePixelRatio || 1);
          const url = new URL(book.image, location.href);
          url.searchParams.set('width', [240, 360, 500, 720].find(width => width >= needed) || 720);
          return url.href;
        };
        const fresh = books.filter(book => !previous.includes(String(book.id)));
        const pool = fresh.length >= slots.length ? fresh : books;
        for (let i = pool.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pool[i], pool[j]] = [pool[j], pool[i]];
        }
        const picks = pool.slice(0, slots.length);
        const sources = picks.map((book, index) => sized(book, slots[index]));
        // Load all replacement covers first, avoiding broken images or mismatched links.
        await Promise.all(sources.map(source => new Promise((resolve, reject) => {
          const image = new Image();
          const timer = setTimeout(() => reject(new Error('Cover timeout')), 10000);
          image.onload = () => { clearTimeout(timer); resolve(); };
          image.onerror = () => { clearTimeout(timer); reject(new Error('Cover unavailable')); };
          image.src = source;
        })));
        if (!this.isConnected) return;
        slots.forEach((link, index) => {
          const book = picks[index], image = link.querySelector('img');
          link.href = book.url;
          link.setAttribute('aria-label', book.title);
          image.removeAttribute('srcset');
          image.src = sources[index];
          image.alt = book.title;
        });
        try { sessionStorage.setItem(storageKey, JSON.stringify(picks.map(book => String(book.id)))); } catch { /* Works without storage too. */ }
      } catch { /* Keep the original covers if the catalog or images are unavailable. */ }
    }
  });
}
